export const DO_SOMETHING = 'DO_SOMETHING';
export const DO_SOMETHING_ASYNC = 'DO_SOMETHING_ASYNC';

// FETCH DASHBOARD
export const FETCH_DASHBOARD_REQUEST = 'FETCH_DASHBOARD_REQUEST';
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS';
export const FETCH_DASHBOARD_FAIL = 'FETCH_DASHBOARD_FAIL';

// FETCH UNPAID CONTRACTS
export const FETCH_UNPAID_CONTRACTS_REQUEST = 'FETCH_UNPAID_CONTRACTS_REQUEST';
export const FETCH_UNPAID_CONTRACTS_SUCCESS = 'FETCH_UNPAID_CONTRACTS_SUCCESS';
export const FETCH_UNPAID_CONTRACTS_FAIL = 'FETCH_UNPAID_CONTRACTS_FAIL';